export enum SentenceLevel {
  Record = 0,
  Offense = 1
}



// WEBPACK FOOTER //
// ./src/models/sentenceLevel.ts